import { Injectable } from '@angular/core';

@Injectable()
export class ContractModificationValidations {
  private static isNoTax(model: any) {
    let noTax = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier === '0<>TIPO_IMPUESTO');
    return noTax;
  }

  constructor() { }

  /*
  // ejemplos en procurementProject.validation.ts
   */
  //Habilitar: total impuesto.
  public valueBudgetTotalTaxes(model: any) {
    let totalTaxes = ContractModificationValidations.isNoTax(model)
      ? 0
      : model.budget.totalTaxes;
    return totalTaxes;
  }

  // Habilitar: Tipo Impositivo
  public enabledTaxRate(model: any) {
    let noTax = ContractModificationValidations.isNoTax(model);
    return !noTax;
    /*if (!noTax) {
      return true;
    }
    return false;*/
  }

  public isPublicSector(model: any) {
    let publicSector = (model.context &&
      model.context.configurations &&
      model.context.configurations.isPublicSector)
      ? model.context.configurations.isPublicSector.value
      : false;
    if (publicSector) {
      return true;
    } else {
      return false;
    }
  }



  public enabledBudgetTotalTaxes(model: any) {
    let cleanBudget = this.isCleanBudget(model);
    let noTax = ContractModificationValidations.isNoTax(model);
    if (!cleanBudget && !noTax) {
      return true;
    }
    return false;
  }

  private isCleanBudget(model: any) {
    let subTypeCodeCorrect = ((this.isServiciesPublic(model) &&
      this.isConcession(model)) ||
      this.isWorkConcession(model) ||
      this.isServicesConcession(model)
    );
    return true;
  }

  private isServiciesPublic(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isServiciesPublic =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '06<>TIPOEXPTE';
      return isServiciesPublic;
    }
    return false;
  }

  private isConcession(model: any) {
    if (model.classification && model.classification.subTypeCode) {
      let isConcession =
        model.classification.subTypeCode === undefined
          ? false
          : model.classification.subTypeCode.identifier === '01<>MODALIDADEXPTE';
      return isConcession;
    }
    return false;
  }

  private isWorkConcession(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isWorkConcession =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '10<>TIPOEXPTE';
      return isWorkConcession;
    }
    return false;
  }

  private isServicesConcession(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isServicesConcession =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '11<>TIPOEXPTE';
      return isServicesConcession;
    }
    return false;
  }



  public valueBudgetTaxType(model: any) {
    if (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier) {
      return model.budget.taxType;
    } else {
      model.budget.taxType = {};
      model.budget.taxType.identifier = '1<>TIPO_IMPUESTO';
      return model.budget.taxType;
    }
  }

  public visibleRegistrationNumber(model: any) {
    return (model != null
      && model.context != null
      && model.context.configurations != null
      && model.context.configurations.registerNumberEnabled != null
      && model.context.configurations.registerNumberEnabled.value === true) ? true : false;
  }

  public setTotalAmount(model: any) {
    let totalTaxes = 0.0;
    if (model.budget.totalTaxes !== undefined && model.budget.totalTaxes !== undefined) {
      totalTaxes = model.budget.totalTaxes;
    }
    let amountExcludingTaxes = 0.0;
    if (model.budget.amountExcludingTaxes !== undefined && model.budget.amountExcludingTaxes !== undefined) {
      amountExcludingTaxes = model.budget.amountExcludingTaxes;
    }
    let totalAmount = 0.0;
    // 555.31 + 955.62 = 1510.9299999999998
    if (amountExcludingTaxes !== 0.0 || totalTaxes !== 0.0) {
      totalAmount = amountExcludingTaxes + totalTaxes;
      let multiplier = Math.pow(10, 2);
      totalAmount = Math.round((totalAmount + Number.EPSILON) * multiplier) / multiplier;
    }
    model.budget.totalAmount = totalAmount;
  }

  /*
   private static isComplementarySystemBaseSD(model: any) {
     if (model.classification && model.classification.complementarySystem) {
       return model.classification.complementarySystem == 'CSDA<>SISTCOMPLEMENTARIO'
     }
     return false;
   }

   private static isComplementarySystemAM_SDA(model: any) {
     if (model.classification && model.classification.complementarySystem) {
       let isAM =
         model.classification.complementarySystem == 'AM<>SISTCOMPLEMENTARIO';
       let isSDA =
         model.classification.complementarySystem == 'SDA<>SISTCOMPLEMENTARIO';
       return isAM || isSDA;
     }
     return false;
   }



   private static isAwardingVariousCriteria(model: any) {
     if (model.classification && model.classification.awardMethod) {
       let isAwardingVariousCriteria =
         model.classification.awardMethod == undefined
           ? false
           : model.classification.awardMethod.identifier ==
           'P<>FORMASADJUDICACION';
       return isAwardingVariousCriteria;
     }
     return false;
   }

   private static isPrivate(model: any) {
     if (model.classification && model.classification.typeCode) {
       let isPrivate =
         model.classification.typeCode == undefined
           ? false
           : model.classification.typeCode.identifier == '09<>TIPOEXPTE';
       return isPrivate;
     }
     return false;
   }
   private static isConsultancy(model: any) {
     if (model.classification && model.classification.typeCode) {
       let isConsultancy =
         model.classification.typeCode == undefined
           ? false
           : model.classification.typeCode.identifier == '03<>TIPOEXPTE';
       return isConsultancy;
     }
     return false;
   }


   private static isGoods(model: any) {
     if (model.classification && model.classification.typeCode) {
       let isGoods =
         model.classification.typeCode == undefined
           ? false
           : model.classification.typeCode.identifier == '02<>TIPOEXPTE';
       return isGoods;
     }
     return false;
   }

   private static isWorks(model: any) {
     if (model.classification && model.classification.typeCode) {
       let isWorks =
         model.classification.typeCode == undefined
           ? false
           : model.classification.typeCode.identifier == '01<>TIPOEXPTE';
       return isWorks;
     }
     return false;
   }
   private static isServices(model: any) {
     if (model.classification && model.classification.typeCode) {
       let isServices =
         model.classification.typeCode == undefined
           ? false
           : model.classification.typeCode.identifier == '04<>TIPOEXPTE';
       return isServices;
     }
     return false;
   }
   private static amountEstimatedAmount(model: any) {
     if (model.budget) {
       let amountEstimatedAmount =
         model.budget.estimatedAmount == undefined
           ? 0
           : model.budget.estimatedAmount;
       return amountEstimatedAmount;
     }
     return 0;
   }
   private static isDesignContest(model: any) {
     if (model.type) {
       let isDesignContest =
         model.type &&
         model.type.identifier != undefined &&
         model.type.identifier == 'CP<>PROCEDIMIENTOSCONTRA';
       return isDesignContest;
     }
     return false;
   }
   private static isCompetitiveDialogue(model: any) {
     if (model.type) {
       let isCompetitiveDialogue =
         model.type &&
         model.type.identifier != undefined &&
         model.type.identifier == 'DC<>PROCEDIMIENTOSCONTRA';
       return isCompetitiveDialogue;
     }
     return false;
   }
   private static isOpenSimplifiedAbreviated(model: any) {
     if (model.type) {
       let isOpen = model.type.identifier == 'AS<>PROCEDIMIENTOSCONTRA';
       let isAbreviated = model.classification.abbreviated != undefined && model.classification.abbreviated;
       return isOpen && isAbreviated;
     }
     return false;
   }
   private static isTenderWithNegotiation(model: any) {
     if (model.type) {
       let isTenderWithNegotiation =
         model.type &&
         model.type.identifier != undefined &&
         model.type.identifier == 'LN<>PROCEDIMIENTOSCONTRA';
       return isTenderWithNegotiation;
     }
     return false;
   }
   private static isAssociationForInnovation(model: any) {
     if (model.type) {
       let isAssociationForInnovation =
         model.type &&
         model.type.identifier != undefined &&
         model.type.identifier == 'API<>PROCEDIMIENTOSCONTRA';
       return isAssociationForInnovation;
     }
     return false;
   }
   private static isNegotiatedWithoutPublicity(model: any) {
     if (model.type) {
       let isNegotiatedWithoutPublicity =
         model.type &&
         model.type.identifier != undefined &&
         model.type.identifier == 'NSP<>PROCEDIMIENTOSCONTRA';
       return isNegotiatedWithoutPublicity;
     }
     return false;
   }
   private static participantsLimit(model: any) {
     if (model.type) {
       let participantsLimit =
         model.characteristicsContractObject.participantsLimit == undefined
           ? false
           : model.characteristicsContractObject.participantsLimit;
       return participantsLimit;
     }
     return false;
   }
   //si es base en acuerdo marco: [esAdjAcuerdoMarco=modoProc.equals("AAM")]
   private static isBasedFrameworkAgreement(model: any) {
     if (model.type) {
       let isModesBasedFrameworkAgreement =
         model.type.identifier != undefined &&
         model.type.identifier == 'AAM<>PROCEDIMIENTOSCONTRA';
       if (model.context && model.context.configurations && model.context.configurations.isModesBasedFrameworkAgreement) {
         isModesBasedFrameworkAgreement =
           isModesBasedFrameworkAgreement ||
           model.context.configurations.modesBasedFrameworkAgreement.value.some(
             t => t === model.type.identifier
           );
       }
       return isModesBasedFrameworkAgreement != undefined
         ? isModesBasedFrameworkAgreement
         : false;
     }
     return false;
   }
   //esMenor = modoProc.equals("M")
   private static isMinorContrat(model: any) {
     let isModesMinor = false;
     if (model.type) {
       isModesMinor = model.type.identifier == 'M<>PROCEDIMIENTOSCONTRA';
       if (model.context && model.context.configurations && model.context.configurations.modesMinorContrat) {
         isModesMinor =
           isModesMinor ||
           model.context.configurations.modesMinorContrat.value.some(
             t => t === model.type.identifier
           );
       }
     }
     return isModesMinor;
   }
   //si es restringuido: [esRestringido = modoProc.equals("R") || (esConcursoProyectos && hayLimiteNumParticipantes)]
   private static isRestrictedContrat(model: any) {
     if (model.type) {
       let isModesRestricted =
         model.type.identifier == 'R<>PROCEDIMIENTOSCONTRA';
       if (model.context && model.context.configurations && model.context.configurations.modesRestricted) {
         isModesRestricted =
           isModesRestricted ||
           model.context.configurations.modesRestricted.value.some(
             t => t === model.type.identifier
           );
       }
       let isDesignContest = model.type.identifier == 'CP<>PROCEDIMIENTOSCONTRA';
       let participantsLimit =
         model.characteristicsContractObject.participantsLimit == undefined
           ? false
           : model.characteristicsContractObject.participantsLimit;
       let isRestricted =
         isModesRestricted || (participantsLimit && isDesignContest);
       return isRestricted;
     }
     return false;
   }

   //si es abierto: [esAbierto = modoProc.equals("A") || (esConcursoProyectos && !hayLimiteNumParticipantes)]
   private static isOpenContrat(model: any) {
     if (model.type) {
       let isModesOpenContract =
         model.type.identifier == 'A<>PROCEDIMIENTOSCONTRA';
       if (model.context && model.context.configurations && model.context.configurations.modesOpen) {
         isModesOpenContract =
           isModesOpenContract ||
           model.context.configurations.modesOpen.value.some(
             t => t === model.type.identifier
           );
       }
       let isOpen =
         isModesOpenContract ||
         (ContractModificationValidations.isDesignContest(model) &&
           !ContractModificationValidations.participantsLimit(model));
       return isOpen;
     }
     return false;
   }

   private static isNegotiated(model: any) {
     if (model.type) {
       let isNegotiated = model.type.identifier == 'N<>PROCEDIMIENTOSCONTRA';
       if (model.context && model.context.configurations && model.context.configurations.modesNegotiated) {
         isNegotiated =
           isNegotiated ||
           model.context.configurations.modesNegotiated.value.some(
             t => t === model.type.identifier
           );
       }
       return isNegotiated;
     }
     return false;
   }

   public isvisibleComplementarySystem(model: any) {
     let isActiveComplementarySystem =
       (model.context &&
         model.context.configurations &&
         model.context.configurations.isActiveComplementarySystem)
         ? model.context.configurations.isActiveComplementarySystem.value
         : false;

     if (isActiveComplementarySystem) {
       return (
         (ContractModificationValidations.isOpenContrat(model) ||
           ContractModificationValidations.isNegotiated(model) ||
           ContractModificationValidations.isRestrictedContrat(model) ||
           ContractModificationValidations.isBasedFrameworkAgreement(model)) &&
         ((ContractModificationValidations.isWorks(model) ||
           ContractModificationValidations.isGoods(model) ||
           ContractModificationValidations.isServices(model)) &&
           !ContractModificationValidations.isAssociationForInnovation(model) &&
           !ContractModificationValidations.isDesignContest(model))
       );
     }

     return false;
   }

   public isVisibleSelectionCriteriaAward(model: any) {
     // Menores con Licitacion Electronica
     // Si es  tipo de procedimiento es distinto de AM o es un CSDA
     let condition1 = (ContractModificationValidations.isMinorContrat(model) && model.classification && model.classification.submissionMethodCode);
     let condition2 = (!ContractModificationValidations.isBasedFrameworkAgreement(model) || (model.classification && model.classification.complementarySystem && model.classification.complementarySystem.identifier == 'CSDA<>SISTCOMPLEMENTARIO'));

     if (condition1) {
       return true;
     }
     if (condition2) {
       return true;
     }

     return false;

   }

   public isRequiredSelectionCriteriaAward(model: any) {
     return (
       ContractModificationValidations.isNegotiated(model) ||
       ContractModificationValidations.isCompetitiveDialogue(model) ||
       ((ContractModificationValidations.isOpenContrat(model) ||
         ContractModificationValidations.isRestrictedContrat(model)) &&
         ContractModificationValidations.isAwardingVariousCriteria(model))
     );
   }

   public isVisibleSelectionCriteria(model: any) {
     return (
       ContractModificationValidations.isRestrictedContrat(model) ||
       ContractModificationValidations.isCompetitiveDialogue(model) ||
       ContractModificationValidations.isTenderWithNegotiation(model) ||
       ContractModificationValidations.isNegotiatedWithoutPublicity(model)
     );
   }

   public isVisibleClassificationCompany(model: any) {
     //visibleClasifEmpre = !esMenor && !esAdjAcuerdoMarco && ((esObras && valorEstimado >= impClasifEmpr)||esServicios);
     if (model.type) {
       let amountSelectionCriteria = model.context &&
         model.context.configurations &&
         model.context.configurations.amountSelectionCriteria;
       return (
         !ContractModificationValidations.isMinorContrat(model) &&
         !ContractModificationValidations.isBasedFrameworkAgreement(model) &&
         ((ContractModificationValidations.isWorks(model) &&
           ContractModificationValidations.amountEstimatedAmount(model) >=
           amountSelectionCriteria.value) ||
           ContractModificationValidations.isServices(model))
       );
     }
     return false;
   }

   public isVisibleSpecialEconomicTerm(model: any) {
     // boolean visibleRegEconomico =(esServicioPublico && esConcesion) || esConcesionObras || esConcesionServicios;
     return (
       (ContractModificationValidations.isServiciesPublic(model) &&
         ContractModificationValidations.isConcession(model)) ||
       ContractModificationValidations.isWorkConcession(model) ||
       ContractModificationValidations.isServicesConcession(model)
     );
   }

   public isVisibleSubTypeCode(model: any) {
     let isActiveSubTypeWorks =
       (model.context &&
         model.context.configurations &&
         model.context.configurations.isActiveSubTypeWorks)
         ? model.context.configurations.isActiveSubTypeWorks.value
         : true;
     if (isActiveSubTypeWorks) {
       return (
         !ContractModificationValidations.isWorkConcession(model) &&
         (ContractModificationValidations.isServiciesPublic(model) ||
           ContractModificationValidations.isGoods(model) ||
           ContractModificationValidations.isWorks(model))
       );
     } else {
       return (
         ContractModificationValidations.isServiciesPublic(model) ||
         ContractModificationValidations.isGoods(model)
       );
     }
   }

   public isVisible(model: any) {
     let isActiveSubTypeWorks =
       (model.context &&
         model.context.configurations &&
         model.context.configurations.isActiveSubTypeWorks)
         ? model.context.configurations.isActiveSubTypeWorks.value
         : true;
     if (isActiveSubTypeWorks) {
       return (
         !ContractModificationValidations.isWorkConcession(model) &&
         (ContractModificationValidations.isServiciesPublic(model) ||
           ContractModificationValidations.isGoods(model) ||
           ContractModificationValidations.isWorks(model))
       );
     } else {
       return (
         ContractModificationValidations.isServiciesPublic(model) ||
         ContractModificationValidations.isGoods(model)
       );
     }
   }

   public isVisibleProcessJustificationNegotiated(model: any) {
     return (
       ContractModificationValidations.isNegotiated(model) &&
       (ContractModificationValidations.isWorks(model) ||
         ContractModificationValidations.isServices(model) ||
         ContractModificationValidations.isGoods(model) ||
         ContractModificationValidations.isWorkConcession(model) ||
         ContractModificationValidations.isServicesConcession(model))
     );
   }

   public isVisibleNoticeDocumentReference(model: any) {
     //boolean visibleAnuInfPrevia = esAbierto || esRestringido || esDCompetitivo || ((esPNegociado && hayPublicidad) || esLicitacionNegociada);
     return (
       ContractModificationValidations.isOpenContrat(model) ||
       ContractModificationValidations.isRestrictedContrat(model) ||
       ContractModificationValidations.isCompetitiveDialogue(model) ||
       ContractModificationValidations.isTenderWithNegotiation(model)
     );
   }

   public provisionalGuaranteeAmount(model: any) {
     if (
       model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage !=
       undefined
     ) {
       let amountGuarantee =
         model.budget != undefined &&
           model.budget.amountExcludingTaxes != undefined
           ? model.budget.amountExcludingTaxes
           : 0;
       if (ContractModificationValidations.isComplementarySystemAM_SDA(model)) {
         amountGuarantee = ContractModificationValidations.amountEstimatedAmount(
           model
         );
       }
       return (
         (amountGuarantee *
           model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage) /
         100
       );
     }
     return undefined;
   }

   private static isComplementarySystem_CBAM_CSDA(model: any) {
     if (model.classification && model.classification.complementarySystem) {
       let complementarySystemBased =
         model.classification.complementarySystem == undefined
           ? false
           : model.classification.complementarySystem.identifier ==
           'CBAM<>SISTCOMPLEMENTARIO' ||
           model.classification.complementarySystem.identifier ==
           'CSDA<>SISTCOMPLEMENTARIO';
       return complementarySystemBased;
     }
     return false;
   }

   public isBasedFrameworkAgreement(model: any) {
     let isActiveComplementarySystem =
       (model.context &&
         model.context.configurations &&
         model.context.configurations.isActiveComplementarySystem)
         ? model.context.configurations.isActiveComplementarySystem.value
         : false;

     if (isActiveComplementarySystem) {
       return ContractModificationValidations.isComplementarySystem_CBAM_CSDA(
         model
       );
     }

     return false;
   }

   public isVisibleCompanyToInvite(model: any) {
     let isVisibleCompanyToInvite = ContractModificationValidations.isMinorContrat(model) || ContractModificationValidations.isNegotiated(model);
     let isCBAM = model.classification.complementarySystem && model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';
     return isVisibleCompanyToInvite && !isCBAM;
   }
   public isVisibleCompanyToInviteCBAM(model: any) {
     let isCBAM = model.classification.complementarySystem && model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';
     return isCBAM;
   }

   public clearFromControlCompanyToInvite(model: any) {
     let isCBAM = model.classification.complementarySystem && model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';
     let isVisibleCompanyToInvite = ContractModificationValidations.isMinorContrat(model) || ContractModificationValidations.isNegotiated(model);
     return isVisibleCompanyToInvite || isCBAM;
   }


   private static isComplementarySystem_CSDA(model: any) {
     let isActiveComplementarySystem =
       (model.context &&
         model.context.configurations &&
         model.context.configurations.isActiveComplementarySystem)
         ? model.context.configurations.isActiveComplementarySystem.value
         : false;

     if (isActiveComplementarySystem) {
       if (model.classification && model.classification.complementarySystem) {
         let isCSDA =
           model.classification.complementarySystem == undefined
             ? false
             : (model.classification.complementarySystem.identifier == 'CSDA<>SISTCOMPLEMENTARIO')
         return isCSDA;
       }
     }

     return false;
   }

   public isVisibleLotsPanel(model: any) {
     let isMinorContract = false;
     if (model.type) {
       isMinorContract = model.type == undefined
         ? false
         : model.type.identifier == 'M<>PROCEDIMIENTOSCONTRA';
     }
     if (isMinorContract) {
       return false;
     }

     if (ContractModificationValidations.isComplementarySystem_CSDA(model)) {
       return false;
     }


     return true;
   }

   public isVisibleCriteriaTechnicalFinancial(model: any) {
     return !ContractModificationValidations.isMinorContrat(model) &&
       !ContractModificationValidations.isBasedFrameworkAgreement(model) &&
       !ContractModificationValidations.isComplementarySystemBaseSD(model) &&
       !ContractModificationValidations.isOpenSimplifiedAbreviated(model)
       ;
   }

   public isVisibleWorkProgram(model: any) {
     let isMinor = ContractModificationValidations.isMinorContrat(model);
     let isConsultancy = ContractModificationValidations.isConsultancy(model);
     let isServices = ContractModificationValidations.isServices(model);
     let isPrivate = ContractModificationValidations.isPrivate(model);
     let isWorks = ContractModificationValidations.isWorks(model);
     return !isMinor && (isConsultancy || isServices || isPrivate || isWorks);
   }

   public isVisibleSubcontractTerm(model: any) {
     return !ContractModificationValidations.isMinorContrat(model) && !ContractModificationValidations.isServiciesPublic(model);
   }

   public isVisibleContractExtension(model: any) {
     return !ContractModificationValidations.isMinorContrat(model) && !ContractModificationValidations.isWorks(model) && !ContractModificationValidations.isPrivate(model);
   }

   public valueFinalFinancialGuaranteePercentage(model: any) {
     if (model.breakdownLot.totalLots.budget.finalFinancialGuarantee) { //si se ha marcado que hay garantia definitiva
       if (model.breakdownLot.totalLots.budget.finalFinancialGuaranteePercentage) {
         return model.breakdownLot.totalLots.budget.finalFinancialGuaranteePercentage; //el valor introducido pr el usuario
       } else {
         //el valor establecido en la configuaracion
         let finalFinancialGuaranteePerc = model.context && model.context.configurations
           ? model.context.configurations.valueDefaultFinancialGuaranteePercentage.value
           : undefined;
         return finalFinancialGuaranteePerc;
       }
     } else {
       return undefined;
     }
   }

   public valueProvisionalGuaranteePercentage(model: any) {
     if (model.breakdownLot.totalLots.budget.provisionalGuarantee) { //si se ha marcado que hay garantia definitiva
       if (model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage) {
         return model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage; //el valor introducido pr el usuario
       } else {
         //el valor establecido en la configuracion
         let valueProvGuaranteePerc = model.context && model.context.configurations
           ? model.context.configurations.valueDefaultGuaranteeProvisional.value
           : undefined;
         return valueProvGuaranteePerc;
       }
     } else {
       return undefined;
     }
   }

   public isVisiblePenaltyClauses(model: any) {
     return !ContractModificationValidations.isMinorContrat(model) && !ContractModificationValidations.isServiciesPublic(model);
   }


   public isVisibleLowTendersDescription(model: any) {
     return !ContractModificationValidations.isMinorContrat(model) && !ContractModificationValidations.isCentralizedPurchases(model);
   }

   public isVisibleFichCriteriaTechnicalFinancial(model: any) {
     let isVisibleCriteriaTechnicalFinancial = !ContractModificationValidations.isMinorContrat(model) &&
       !ContractModificationValidations.isBasedFrameworkAgreement(model) &&
       !ContractModificationValidations.isComplementarySystemBaseSD(model) &&
       !ContractModificationValidations.isOpenSimplifiedAbreviated(model)

     let isVisibleCompanyToInvite = ContractModificationValidations.isMinorContrat(model) || ContractModificationValidations.isNegotiated(model);
     return isVisibleCriteriaTechnicalFinancial || isVisibleCompanyToInvite;
   }

   public isVisiblePriceRevision(model: any) {
     let isVisible = !ContractModificationValidations.isMinorContrat(model) && !ContractModificationValidations.isBasedFrameworkAgreement(model) && !ContractModificationValidations.isCentralizedPurchases(model);
     return isVisible;

   }

   public isVisiblePriceRevisionWorks(model: any) {
     let isVisible = !ContractModificationValidations.isMinorContrat(model) && !ContractModificationValidations.isBasedFrameworkAgreement(model) && !ContractModificationValidations.isCentralizedPurchases(model);
     return isVisible && ContractModificationValidations.isWorks(model);

   }

   public isVisiblePriceRevisionNotWorks(model: any) {
     let isVisible = !ContractModificationValidations.isMinorContrat(model) && !ContractModificationValidations.isBasedFrameworkAgreement(model) && !ContractModificationValidations.isCentralizedPurchases(model);
     return isVisible && !ContractModificationValidations.isWorks(model);

   }

   public isVisibleCategory(model: any) {
     if (ContractModificationValidations.isComplementarySystem_CSDA(model)) {
       if (model.contractingSystem.originalContractingSystemID != undefined && model.contractingSystem.originalContractingSystemID) {
         return true;
       }
     }

     return false;
   }

   private isSpecialAdministrative(model: any) {
     //boolean esAdministrativoEspecial = tipoExpte.equals("07") || tipoExpte.equals("09") || tipoExpte.equals("12");
     if (model.classification && model.classification.typeCode) {
       let isSpecialAdministrative =
         model.classification.typeCode == undefined
           ? false
           : (model.classification.typeCode.identifier == '07<>TIPOEXPTE' || model.classification.typeCode.identifier == '09<>TIPOEXPTE' || model.classification.typeCode.identifier == '12<>TIPOEXPTE');
       return isSpecialAdministrative;
     }
     return false;
   }


   public isVisiblePrice(model: any) {
     // !hayIngreso && (esConcesion  || esConcesionObras || esConcesionServicios)
     return (
       (!model.breakdownLot.totalLots.specialEconomicTerm.income &&
         (ContractModificationValidations.isConcession(model) ||
           ContractModificationValidations.isWorkConcession(model) ||
           ContractModificationValidations.isServicesConcession(model)))
     );
   }

   public valueProvisionalGuaranteePercentage2(model: any) {
     if (model.breakdownLot.totalLots.budget.provisionalGuarantee) { //si se ha marcado que hay garantia definitiva
       if (model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage) {
         return model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage; //el valor introducido pr el usuario
       } else {
         //el valor establecido en la configuaracion
         return model.context.configurations.valueDefaultGuaranteeProvisional.value;
       }
     } else {
       return undefined;
     }
   }


   public valueProvisionalGuarantee(model: any) {

     let isAM = model.classification.complementarySystem && model.classification.complementarySystem == 'AM<>SISTCOMPLEMENTARIO';
     let amountGuarantee = 0;
     let provisionalGuaranteeAmount = 0;

     if (isAM != undefined) {
       if (model.budget && model.budget.estimatedAmount != undefined)
         amountGuarantee = model.budget.estimatedAmount;
     } else {
       if (model.budget && model.budget.amountExcludingTaxes != undefined)
         amountGuarantee = model.budget.amountExcludingTaxes
     }

     if (model.breakdownLot.totalLots.budget && model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage != undefined) {
       if (amountGuarantee != 0) {
         return ((amountGuarantee * model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage) / 100);
       }
     }
     return 0;
   }

   private static isCentralizedPurchases(model: any) {
     if (model.type) {
       return model.type.identifier == 'T<>PROCEDIMIENTOSCONTRA';
     }
     return false;
   }

   public isVisibleMethod(model: any) {
     let isVisibleMethodRevPrice = model.breakdownLot.totalLots &&
       model.breakdownLot.totalLots.priceRevision &&
       model.breakdownLot.totalLots.priceRevision.priceRevision &&
       (model.breakdownLot.totalLots.priceRevision.priceRevision == 'SI' || model.breakdownLot.totalLots.priceRevision.priceRevision == 'SOLO_PRORROGA') &&
       !ContractModificationValidations.isWorks(model)
     return isVisibleMethodRevPrice;
   }

   public isVisibleBudgetDeterminationSystem(model: any) {
     //plantilla.setApariencia("panelDetPresupuesto", null, (esConsultoria || esServicios) && !esComprasCC , true);
     return ((ContractModificationValidations.isConsultancy(model) || ContractModificationValidations.isServices(model)) && (!ContractModificationValidations.isCentralizedPurchases(model)));
   }

   private static isRate(model: any) {
     return (model.breakdownLot.totalLots &&
       model.breakdownLot.totalLots.specialEconomicTerm &&
       model.breakdownLot.totalLots.specialEconomicTerm.rate);
   }
   private static isCompensation(model: any) {
     return (model.breakdownLot.totalLots &&
       model.breakdownLot.totalLots.specialEconomicTerm &&
       model.breakdownLot.totalLots.specialEconomicTerm.compensation);
   }
   private static isCanon(model: any) {
     return (model.breakdownLot.totalLots &&
       model.breakdownLot.totalLots.specialEconomicTerm &&
       model.breakdownLot.totalLots.specialEconomicTerm.canon);
   }
   private static isPrice(model: any) {
     return (model.breakdownLot.totalLots &&
       model.breakdownLot.totalLots.specialEconomicTerm &&
       model.breakdownLot.totalLots.specialEconomicTerm.price);
   }

   private static isCleanBudget(model: any) {
     let subTypeCodeCorrect = ((ContractModificationValidations.isServiciesPublic(model) && ContractModificationValidations.isConcession(model)) ||
       ContractModificationValidations.isWorkConcession(model) ||
       ContractModificationValidations.isServicesConcession(model)
     );

     let notPrice = (!ContractModificationValidations.isPrice(model) &&
       (ContractModificationValidations.isCanon(model) || ContractModificationValidations.isRate(model) || ContractModificationValidations.isCompensation(model)));

     if (subTypeCodeCorrect && notPrice) {
       // Se limpia el campo Tipo Impositivo
       model.budget.taxRate = '';
       return true;
     }


     return false;
   }

   private static isNoTax(model: any) {

     let noTax = (model.budget &&
       model.budget.taxType &&
       model.budget.taxType.identifier == '0<>TIPO_IMPUESTO');

     return noTax;
   }

   public valueBudgetAmountExcludingTaxes(model: any) {
     let amountExcludingTaxes = ContractModificationValidations.isCleanBudget(model) &&
       (model.budget != undefined &&
         model.budget.amountExcludingTaxes != undefined)
       ? 0
       : model.budget.amountExcludingTaxes;

     return amountExcludingTaxes;
   }

   public enabledAmountExcludingTaxes(model: any) {
     return !ContractModificationValidations.isCleanBudget(model);
   }

   public valueBudgetTotalTaxes(model: any) {
     let totalTaxes = (ContractModificationValidations.isCleanBudget(model) || ContractModificationValidations.isNoTax(model))
       ? 0
       : model.budget.totalTaxes;

     return totalTaxes;

   }





   // Habilitar: Tipo de Impuesto
   public enabledBudgetTaxType(model: any) {
     return !ContractModificationValidations.isCleanBudget(model);
   }

   // Visibilidad: Tabla de Anualidades
   public isVisibleBudgetAccountLine(model: any) {
     let visibleAnu = (model.classification && model.classification.complementarySystem &&
       model.classification.complementarySystem != 'AM<>SISTCOMPLEMENTARIO' && model.classification.complementarySystem != 'SDA<>SISTCOMPLEMENTARIO');
     let cleanBudget = ContractModificationValidations.isCleanBudget(model);

     if ((visibleAnu != undefined && visibleAnu) || !cleanBudget) {
       return true;
     }
     return false;
   }

   // Visibilidad Cofinanciacion
   public isVisibleCofinancing(model: any) {
     let cleanBudget = ContractModificationValidations.isCleanBudget(model);
     if (cleanBudget != undefined && !cleanBudget) {
       return true;
     }
     return false;
   }

   // Habilitar: Cofinanciación
   public enabledCofinancing(model: any) {
     return !ContractModificationValidations.isCleanBudget(model);
   }

   // Valor: Tipo impositivo
   public valueTaxRate(model: any) {
     let cleanBudget = ContractModificationValidations.isCleanBudget(model);
     let noTax = ContractModificationValidations.isNoTax(model);
     let taxRate = cleanBudget || noTax
       ? ''
       : model.budget.taxRate;
     return taxRate;
   }

   // Habilitar: Tipo Impositivo
   public enabledTaxRate(model: any) {
     let cleanBudget = ContractModificationValidations.isCleanBudget(model);
     let noTax = ContractModificationValidations.isNoTax(model);
     if (!cleanBudget && !noTax) {
       return true;
     }
     return false;
   }

   // Visible: Criterios de adjudicación de Acuerdos Marco (AAM-CBAM)
   public isVisibleFrameworkAgreementCriteria(model: any) {
     let isActiveComplementarySystem =
       (model.context &&
         model.context.configurations &&
         model.context.configurations.isActiveComplementarySystem)
         ? model.context.configurations.isActiveComplementarySystem.value
         : false;

     if (isActiveComplementarySystem) {
       return (model.type && model.type.identifier == 'AAM<>PROCEDIMIENTOSCONTRA') && (model.classification && model.classification.complementarySystem && model.classification.complementarySystem.identifier != 'CSDA<>SISTCOMPLEMENTARIO')
     }

     return false;
   }

   private static isVisibleAccountLine(model: any) {
     let visibleAnu = (model.classification && model.classification.complementarySystem &&
       model.classification.complementarySystem != 'AM<>SISTCOMPLEMENTARIO' && model.classification.complementarySystem != 'SDA<>SISTCOMPLEMENTARIO');
     let cleanBudget = ContractModificationValidations.isCleanBudget(model);

     if ((visibleAnu != undefined && visibleAnu) || !cleanBudget) {
       return true;
     }
     return false;
   }

   private static isVisibleLots(model: any) {
     let isMinorContract = false;
     if (model.type) {
       isMinorContract = model.type == undefined
         ? false
         : model.type.identifier == 'M<>PROCEDIMIENTOSCONTRA';
     }
     if (isMinorContract) {
       return false;
     }

     if (ContractModificationValidations.isComplementarySystem_CSDA(model)) {
       return false;
     }

     return true;
   }

   // Visible desglose presupuestario
   public isVisibleHeaderBudgetBreakdown(model: any) {
     // Se visualiza la cabecera de desglose presuouestario, si existen anualidades o lotes
     let visibleBudgetAccountLine = ContractModificationValidations.isVisibleAccountLine(model);
     let visibleLotsPanel = ContractModificationValidations.isVisibleLots(model) && model.breakdownLot && model.breakdownLot.apportioned;
     if (visibleBudgetAccountLine || visibleLotsPanel) {
       return true;
     } else {
       return false;
     }

   }

   //esAbiertoSimplificado = type.equals("AS")
   private static isSimplifiedOpen(model: any) {
     let isSimplifiedOpen = false;
     if (model.type) {
       let isSimplifiedOpen =
         model.type &&
         model.type.identifier != undefined &&
         model.type.identifier == 'AS<>PROCEDIMIENTOSCONTRA';
       return isSimplifiedOpen;
     }
     return false;

   }

   // Visible Garantia provisional
   public isVisibleprovisionalGuarantee(model: any) {
     // !esMenor && !esComprasCC && !esAbiertoSimpli
     if (!ContractModificationValidations.isMinorContrat(model) && !ContractModificationValidations.isCentralizedPurchases(model) && !ContractModificationValidations.isCentralizedPurchases(model)) {
       return true;
     }
     return false;
   }
  */
}